<ng-container *transloco="let t; prefix: 'tasks.taskDetail.products.editConfirmation'">
  <div class="product-confirm-dialog-content">
    <div class="product-confirm-dialog-header">
      <span class="product-confirm-dialog-title headline-small">{{ t('title') }}</span>
    </div>

    <div class="product-confirm-dialog-body">
      <span class="body-small">{{ t('description') }}</span>

      <form class="comment-form" [formGroup]="form">
        <label for="product-changes-comment" class="body-small">{{ t('comment') }}</label>
        <textarea
          id="product-changes-comment"
          class="comment-textarea body-medium"
          rows="3"
          formControlName="comment"
          required></textarea>
      </form>
    </div>
  </div>

  <div class="product-confirm-dialog-footer">
    <div class="product-confirm-dialog-actions">
      <button matButton type="button" [mat-dialog-close]="undefined">
        {{ t('cancel') }}
      </button>
      <button
        matButton="filled"
        type="button"
        [disabled]="!form.controls.comment.value.trim()"
        (click)="confirm()">
        {{ t('confirm') }}
      </button>
    </div>
  </div>
</ng-container>
